import React from 'react'
import Tilt from 'react-parallax-tilt';
import { NavLink } from 'react-router-dom';

const ContactCard = (props) => {
  return (
    <>
    <div className="contact_container">
        <Tilt glareEnable="true" glare-max-opacity="0.7" >
            <div className='contact_card'>
                <div className="contact_content">
                    <h2>0prep</h2>
                    <h3>{props.heading}</h3>
                    <p>{props.data}</p>
                    <NavLink to={props.src}>{props.button}</NavLink>
                </div>
            </div>                
        </Tilt>

            
    </div> 
    
    
    </>
  )
}

export default ContactCard